import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import Collections from './components/Collections';
import Spotlight from './components/Spotlight';
import About from './components/About';
import Solutions from './components/Solutions';
import Brands from './components/Brands';
import Products from './components/Products';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Support from './components/Support';
import Footer from './components/Footer';
import ChatWidget from './components/ChatWidget';
import StoreExperience from './components/StoreExperience';
import BrandPreview from './pages/BrandPreview';
import { Toaster } from './components/ui/toaster';

const Home = () => (
  <>
    <Header />
    <main>
      <Hero />
      <Collections />
      <Spotlight />
      <About />
      <Solutions />
      <Brands />
      <Products />
      <Testimonials />
      <StoreExperience />
      <Contact />
      <Support />
    </main>
    <Footer />
    <ChatWidget />
  </>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/brand-preview" element={<BrandPreview />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
